<template>
    <div :class="{'hidden-checkbox': isHidden}">
        <v-checkbox
                class="checkbox"
                :error="error"
                @change="onChange"
                color="info"
                v-model="answer"
                v-for="(item, i) in items"
                :key="i"
                :label="item.answer"
                :value="getValue(i)"
                hide-details
                :dark="dark"
        />
        <v-text-field v-if="isOther" :error="error" @input="onChange" v-model="answerInput" label="Введите текст"/>
    </div>
</template>
<script>
    export default {
        props: {
            dark: Boolean,
            error: Boolean,
            hasId: Boolean,
            hasIndex: Boolean,
            items: {
                type: Array,
                default: () => []
            },
            value: Array,
            id: [String, Number],
            isHidden: Number,
            indexOffset: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                answer: [],
                answerInput: ''
            }
        },
        methods: {
            onChange () {
                let value = this.result
                this.$emit('input', value)
            },
            getValue (i) {
                let item = this.items[i]

                if (this.hasId) {
                    return item.id
                } else if (this.hasIndex) {
                    return (i + this.indexOffset).toString()
                } else {
                    return item.value || item.answer
                }
            }
        },
        computed: {
            otherId () {
                if (this.otherItemsIndex > -1) {
                    return this.items[this.otherItemsIndex].id
                }
            },
            otherItemsIndex () {
                return this.items.findIndex(item => item.answer === 'Другое')
            },
            otherIndex () {
                if (this.hasId) {
                    return this.answer.indexOf(this.otherId)
                } else if (this.hasIndex) {
                    let index = (this.otherItemsIndex + this.indexOffset).toString()
                    return this.answer.indexOf(index)
                }
            },
            isOther () {
                return this.otherIndex > -1
            },
            result () {
                let answer = [].concat(this.answer)
                if (this.isOther) {
                    answer.splice(this.otherIndex, 1)
                    answer.push(this.answerInput)
                }
                return answer
            }
        },
        watch: {
            id () {
                this.answer = []
                this.answerInput = ''
            }
        }
    }
</script>
<style lang="stylus" scoped>
    .hidden-checkbox {
        opacity 0
        height 0
        overflow hidden
        pointer-events none
    }

    .checkbox {
        height auto
        position relative
        margin-bottom 15px

        /deep/ .input-group__input {
            position absolute
            top 50%
            transform translateY(-58%)
            left 0
            min-height 24px
        }

        /deep/ .material-icons {
            height 24px
        }

        /deep/ label {
            position relative
            flex 1 0 100%
            max-width calc(100% - 32px)
            white-space normal
            word-wrap break-word
            height auto
            top 0%
            overflow initial
            line-height: 1.3
        }
    }
</style>